var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo, useReducer } from 'react';
import { closeLoading, initialUIState, showLoading, uiReducer } from '@/store';
export const UIContext = createContext({
    state: initialUIState,
    dispatch: () => undefined
});
export const useUI = () => {
    const ctx = useContext(UIContext);
    const withLoading = useCallback((fn) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            ctx.dispatch(showLoading());
            return yield fn();
        }
        finally {
            ctx.dispatch(closeLoading());
        }
    }), [ctx.dispatch]);
    return Object.assign(Object.assign({}, ctx), { withLoading });
};
export const UIProvider = ({ children }) => {
    const [state, dispatch] = useReducer(uiReducer, initialUIState);
    const value = useMemo(() => ({
        dispatch,
        state
    }), [state]);
    return _jsx(UIContext.Provider, Object.assign({ value: value }, { children: children }));
};
